import { useLayoutEffect, useRef } from "react";
import { useSkillMemoryStore } from "@/application/stores/skillMemoryStore";
import { createSkillMemoryRepository } from "@/infrastructure/persistence/skill-memory-repository-factory";

/**
 * 起動時にスキル記憶（間隔反復）を一度だけ読み込む。
 * Progress と同様、ペイント前に同期読込してちらつきを防ぐ。
 */
export function useSkillMemoryBootstrap(): void {
  const setMemory = useSkillMemoryStore((state) => state.setMemory);
  const bootstrapped = useRef(false);

  useLayoutEffect(() => {
    if (bootstrapped.current) {
      return;
    }
    bootstrapped.current = true;
    setMemory(createSkillMemoryRepository().load());
  }, [setMemory]);
}
